import { REACT_APP_ENV } from 'utils/environmentUtils';

export const MINIMUM_LICENSE_QUANTITY = 1;
export const STRIPE_KEY =
  REACT_APP_ENV === 'production' ? 'pk_live_eA1m0upFilM0NXYpBOV14bwM' : 'pk_test_2rq6AYQ3BGARMFYjrVR6MQHT';

export interface IAccount {
  license_quantity?: number;
}
